"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemStarRating = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var react_jss_1 = require("react-jss");
var StarKind;
(function (StarKind) {
    StarKind["star"] = "star";
    StarKind["starHalf"] = "starHalf";
    StarKind["starBorder"] = "starBorder";
})(StarKind || (StarKind = {}));
var FullStarImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADWUlEQVRYhe2WW2wMYRTHfzPbbqvVSgUV17SihPDgBSEVPAiRIGkQ4ZWKuL54beIJIeKS4MmbS4gIQUKDJqJPQqSCuN+iRZeust3ZmZEzzsjYrpndIpFwkpP99pv/Od855zuXj//0z5PRxwAYWb9u1m/Bir5paclDoN6TMYU7zzFb9gYu5ArgKBdkRFGhFuvhcaC4vJSNutcKWEAasAtVljep92J06Y61TIjHmScsa9nTbwVda0EGqPJioGLxTBqBmLCuK/TbHzVADuxXN5LqmqEs8TdlLXvyTTG/zwAJu1GPadR7ikuA/rvX0VBUTKWPkbXsyTfFxFR3ZDSyAYay6Yd3Ui0lGxoYPGoI1UUxRqfS1EyfyOqqSkYEBRNdvLzRxuHSOE8yNs+ed9C+9yRv7zymRxPTDlSJG2aAHFzcdYHdFf1YisnAKC9CyaEz+YUTlfPZopViBw3IvgLf+/jYFex8+Y6rv3Q4IDpEl5Zur2vJlQPeXbcnKBvZwKGz1znZ18NFVnSIrkBu9DosSP4ViLXlQNXRZj64LplZkxlrmPlVjWNjNx3hbOMumoGPyt3wPR++X0GukvGvoUibS/9rt8i0PSE1fyqjS+LhZZbsxlq5jcsHz3ALaFd+D3zSTukE8bk8chT4SQXfCJ9q4X7bUzqjvBeMYH25sMOFfpgFbguuUf+DAa7f/UyT8sljqIoyQDCmyWvH4ZnkINCh4U/nGla9IiBGuC3ePflGJMSLZXOIl5V6uRFKghGsep4IeG/nmpQ/TSo1wtLESS2aQU025tRV3gtn7ys2pbJW2ITMZxx7tTuplnH+xuPXJNfv4d75Vi/BWDCN6n2bGF87zBtIKNbIp9VHGRDzeVQ1dZZFz4HT3Nx6iAdpi8/AFwGdb+XF5VXc3b6GunVLmCLYoOyvRMCbDcvnMujVOx4sa6L59kMyGlap7aTiKtIWAzbv59GRi1w63sRckTnW7CVh6ECKmlbSBwaAN2qH69rQrE7oL37T0l9XjXulPeCj5kOfIuCqt0lV9kH/S/i7NMnQNivJWKaPkh6VsaLeiFEG2KqsS0tJkiqjHqV07evpDjzLnEAVhL4Ro64gFmjLfkY7erAd6Gz++yEXzgkzIsoAI8A+udmPij5g/9NfQsBXBGEeE7rcO6oAAAAASUVORK5CYII=";
var HalfStarImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEJElEQVRYhe2Wf2jUZRzHX9/73t12W1Ncug28bd6kuXIWFJaVHmRRrazVZhpaFKG1RJQG/bB/RlFmhZZklBoWGAZLYzJptARhrLJcRAyrLcz5a3Ntbm636Xl33/vG8/Vzdn693XmjIMgPPDwPz/N8Pp/38/m8n+fzcEX+96KNMwCarTdtfdqG0tVxqDawhzvURO4C9gFR1cyW1CA0/99j5zgAKOduwJWdyWqZ2w+EgRBgpGssHdEEdOZbz3Kd2809bjf3qrGaU2uaP72ojgeAC8h5aC41gK5syDhH1v5VAMqhp7SQfF8BD6uJUIiAr4AqNSdR0P9pADHSKcMZwFXvrKTa6WKCWvzqAAecLnI2rqJarak9mh9d8+O4nHTYSajZHOqzSshYtZApRXnkO3WKgyF8t5WzJKawdjuH7p/DvFtnsrR5PSMuJ0cjBkd6TtHzQQP9mp+gENOQm2LGXdtLEGri2DXcxIYcD4twkJvsBN4qPvysjpvn3cCNCTdEGQicpX5CBbVyU4xkABwSFU/+JK5u28rb3jyqkgEorOZ9p06gci4ZM4rQC3LJnjkNX2kR89X6iT6+uGkZz/cOMgCcASISiQsO7WLluneQrMKFbG78hp3JAGgaZ7tO0r9xJ7+v2MDB3a0MevOYrdaa9lPvrWazsiVvxyUETQTAjGv6g2vYV7eN3VEj8QPj1BkG63SBN56mfNuLrPa48az7lB33vUCzRNm0534sAKbkKCThGgFGX/2E9kV1fB0YtXJ4kegORoGhJyuY+NJSVkYMwjXr+WjNFn5QutLOxL2SZjIASH5C4vwUcFK1XS10HOyyTmpPgcppaG8b3ZhEj/VxeEsj7aLbJ/2I2Iza9RNFIB7An8Bx4IjDQff105lkN1C72GK/+3gfkb4h/ijOo8TtsoB2Kw4KiAsA7MVqLA4YcSAG1SkWz8edlWkR6SKpqeSJo5/z+mN3c23HMQ45XXiWL2AyWNwYijk3WzASVcpkL6Eh9/YcEKy8HZ99w942Or9t56fCfMq2v8zaaQXMUPMVt1AmB1D6YeV8LCeXU44VSG1WyXnjSg53M1y7iR8bWvlFhXj5A3z/2jIqvXnnQV7jpTzuVU1pPJnosVaUT2k4zLl36/mu7HF2NbTysxB0aGsjncWP8N7HX7InEiY4dYpVnl1x+uMGYJ3i0TuZfKKfztnP8OZzm2gKhekAfgU6gS6gJxii/6l1NM9ZwSvd/fy25C6LB45UUUgVIlVeJ4JVaqfKWJO7PSgEU7cmS9ayxemQREfdotOKQ2M5SMUBU4gUAHrFWFgelmEhKFKmTwsApxAwIH3SP2IqAIY4GRZjDikmQWmRODujsW+ZRCUoukn/iKlSoMdVyBhfouLYiHvZYv+HRPuiyUCkAqAluE5jFZZ09l6R/4gAfwE5yl5ZKDZCcwAAAABJRU5ErkJggg==";
var StarBorderImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEc0lEQVRYhe2WfUzVVRjHP/eVe7mAQXIxosvLChzC5uYiKVqr0UCjmthi05rNMGoaLrf4r/6pLeOPXG9qamvN0OYfLAfqHLi25rhg4480cpBCAgJx4fJy7xUu3Jd27p7rrne3S1BtbflsZ+f8fuc55/me5+V7Dnflfy+aFTpAE9UHo/plb7TcNVrVnK08qX6kVfE9EJC2LBD6FQBQxo2AwWJir/zrBBaBBcC/3M2WIxoBbWp8g0KjkQqjkUo1Vv9kblleXQkAA5C85XHqAJ3aQ8bJMvevAlAGTWttpOdkUO2+hUO13DVUF9iwihd0/zSAcNKpjRMAy8f1VOsNpLTa6Wy1Y9fpSfl0L9VqTnR0smZJb0QraKIM6orzSKh/gXSblYwEIzbvAtkb1/FakonM/O00qkV9TTS45xnr+oUjBj2DPj83RicZPfQdE/Ye5iUx/RFVEowHQBk2zJ7jo2QzL6IlLRbyH6/SWVJHsxp3HWZLSSGlMY8YwOma41TKJvZJpfjjAdBKJpszUrm3+xiN96ezNXTKQS78PED/mBPPwCjulg4cvYN41FyBDcvzZWTk3YfFmkrSuhxy8208peZuOmjeUMvbv0/hBG4BPvHEnwJIkIxWSZV5tpGdmzZS4/XifvMTvjjaQq9sNAch9yLJZwYSd1SSf3AfdYkmks91cmpzA18CI8A44AK8kQCiMzYcAqMk1KqmNiZMBlxPrGd9VSmP3JPMzfOX6AEcwAQwKwSk3V9HaePr7DHoMXzYxLc799MuRpWOR4zfEYJYJaOJCEXoZBe6mRmZ5EZlCUVlxTzqnqPN3sM1YFo8EazfyoPv1/LBog/v7gN81XiSn4ApYBJC7ncL0ECksVhlGBBFtyxWrps82kLP4DgDar6lg2E5zZw07xk7wwQJDDkYONLCFVnrkD6mcSXRd0EwCsDtktFp8eVkkOuY5re+oVAima4ep0arIVjwEj9cHyHgmKE/20qe0YBzYTEEfETC5IkAcMdlFcsDQYlTGMSMiuGuZ0nTG7D0DXPt1Wconmjhm7XZHMy3cUiNa6so6h3iut6AeVcVqyXuMxGn98e6KePRZvj0it8t775CZYGNEr0O/fZyahLNZP46RJtzlv4sK489V0qFVoshxUJqMMjAiXYuCQBPvBvyr1zHIUoteIAi9ZG5mpzxKUbf+5oTnzVzWf3bU83ld3awLctKrvp+KCukq1kJFUeLKkfFhFnu85xJ0JNyvI323Qe4OOcNlZdb9JPMCSR//hZlLz9NudeHK6mCzRBKVqeEIKYsdXMpDyVuKydvQwGFmxo4dvg0vT5/KL5TUobKxT6fn8Dpiwye7aKj4mFSJ2fpvtIfSsS5eCFYygOKB1YBGcAaGQfEaDi+hElLeq3MjUkJT0cwZswTxpOgXCAu0Z0VLvdE0CpC39MCQC8ud0kf9424FAC/GLlNtwJgXpovYh9PxLMsIPPepd6IS4VAF0HLYc4IiGF/BLOF3w+x9AJ/Jwc0McopGP2oWIHuXfmPCPAHbCOQi9dDNvcAAAAASUVORK5CYII=";
var usePerformerItemStarRatingStyles = (0, react_jss_1.createUseStyles)((_a = {
        starWrapper: {
            marginInlineStart: "-2px",
        },
        starBase: {
            width: "14px",
            height: "14px",
            backgroundSize: "16px 16px",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            display: "inline-block",
            marginInlineEnd: "-2px",
            marginBottom: "-1px",
        }
    },
    _a[StarKind.star] = {
        backgroundImage: "url(".concat(FullStarImage, ")"),
    },
    _a[StarKind.starHalf] = {
        backgroundImage: "url(".concat(HalfStarImage, ")"),
    },
    _a[StarKind.starBorder] = {
        backgroundImage: "url(".concat(StarBorderImage, ")"),
    },
    _a));
function getStarKinds(numberOfStars) {
    return (0, Utilities_1.getNumberRange)(0, 5).map(function (starPosition) {
        var starAtCurrentPosition = numberOfStars - starPosition;
        if (isFullStar(starAtCurrentPosition)) {
            return StarKind.star;
        }
        if (isHalfStar(starAtCurrentPosition)) {
            return StarKind.starHalf;
        }
        return StarKind.starBorder;
    });
}
function isFullStar(star) {
    return star >= 1;
}
function isHalfStar(star) {
    return star > 0 && star < 1;
}
var PerformerItemStarRating = function (_a) {
    var stars = _a.stars;
    var classes = usePerformerItemStarRatingStyles();
    return (React.createElement("div", { className: classes.starWrapper }, getStarKinds(stars).map(function (starKind, i) {
        return React.createElement("div", { key: i, className: "".concat(classes.starBase, " ").concat(classes[starKind]) });
    })));
};
exports.PerformerItemStarRating = PerformerItemStarRating;
//# sourceMappingURL=PerformerItemStarRating.js.map